import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarker } from '@fortawesome/pro-regular-svg-icons/faMapMarker'

export const defaultTranslations = {
    pluginName: 'Map',
    pluginDescription: 'Insert a map from Google Maps.',
}

export const defaultSettings = {
    defaultText: '<p>Enter text here.</p>',

    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faMapMarker} size="3x" />,
}
